import GHLAuth from './ghlAuthContainer';

export default GHLAuth;
